<template>
    <div>
      <div class="text-center flex justify-center">
          <div class="text-center mt-4 w-10/12">
            <SidebarTitle icon="Edit3Icon" title="title" />
            <vs-input
              color="dark"
              label=""
              v-model="task.title"
              name="title"
              v-validate="'required'"
              data-vv-name="title"
              class="w-full"
              autocomplete="off"
              ref="titleInput"
              @keyup.enter.native.stop="save"
            />
          </div>
        </div>
        <label v-if="errors.has('title')" class="text-center text-danger block text-sm mt-2 mb-5">
          {{ errors.first('title') }} <br />
        </label>

        <ColorPicker v-model="task.backgroundColor" class="mt-8"/>

        <RelatedAreas :key="`related-areas2-task-${editedEntity.id}`" class="mt-8" v-model="task.relatedAreas" :m="task" />

        <DeadlinePicker v-if="showDeadline" v-model="deadlineRaw" class="mt-8" :taskMetadates="true" :showPickerInitially="!edit"/>

       <Editor v-model="task.notes"/>

        <DiveDeeper>
          <DiveDeeperItem title="why is this important to me?" v-model="task.whyDescription"/>

          <DiveDeeperItem title="what would I gain by achieving this?" v-model="task.gainDescription"/>

          <DiveDeeperItem title="what are possible risks and obstacles?" v-model="task.riskDescription"/>
        </DiveDeeper>

        <MakeIt title="make it effective">

        <SidebarTitle :small="true" icon="" title="how much effort does it take?" class="mt-8" />


        <div class="flex justify-center text-center">
          <Checkbox :key="`${$vnode.key}-effort-low`" :namespace="`${$vnode.key}-effort-low`" class="mx-2" initValue="low" title="low" :singleSelect="true" v-model="task.makeIt.effort" />

           <Checkbox :key="`${$vnode.key}-effort-high`" :namespace="`${$vnode.key}-effort-high`" class="mx-2" initValue="high" title="high" :singleSelect="true" v-model="task.makeIt.effort" />
        </div>

        <SidebarTitle :small="true" icon="" title="how much impact will it make?" class="mt-8" />

        <div class="flex justify-center text-center">
          <Checkbox :key="`${$vnode.key}-impact-low`" :namespace="`${$vnode.key}-impact-low`" class="mx-2" initValue="low" title="low" :singleSelect="true" v-model="task.makeIt.impact" />

           <Checkbox :key="`${$vnode.key}-impact-high`" :namespace="`${$vnode.key}-impact-high`" class="mx-2" initValue="high" title="high" :singleSelect="true" v-model="task.makeIt.impact" />
        </div>


        <div :class="{ 'opacity-0': !makeItTitle }" class="font-italic flex justify-center text-center my-4">
          {{makeItTitle}}
        </div>


        </MakeIt>


        <InfoCard v-if="false" title="short-term & one time">
          <p class="mb-3"><span class="font-bold">Task ‑ something to be done.</span> It is an activity that needs to be accomplished within a defined period of time in order to work towards your goals and dreams. Tasks can be broken down further into smaller subtasks.</p>
          <p class="mb-3 font-bold">The secret of getting ahead is getting started.</p>

          <p class="italic">„Better to complete a small task well, than to do much imperfectly.“ — Plato</p>
        </InfoCard>


    </div>
</template>
<script>
import _ from 'lodash'
// import trackAnalytics from '@/helpers/trackAnalytics'
import { formatyyymmdd, isMetadate, parseInCurrentTimezone, isFuture } from '@/helpers/date'
import trackAnalytics from '@/helpers/trackAnalytics'
import ColorPicker from '@/views/Self-Improvee/Generic/ColorPicker'
import DiveDeeper from '@/views/Self-Improvee/Planner/DiveDeeper'
import DiveDeeperItem from '@/views/Self-Improvee/Planner/DiveDeeperItem'

export default {
  components: {
    ColorPicker,
    DiveDeeper,
    DiveDeeperItem
  },
  props: {
    editedEntity: {
      type: Object,
      required: false,
      default: () => {}
    },
    showDeadline: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  data () {
    return {
      task: {},
      deadlineRaw: '',
    }
  },
  watch: {
    editedEntity: {
      immediate: true,
      async handler (editedEntity) {
        if (!editedEntity) return

        this.task = _.merge({}, this.taskDefaults, editedEntity)

        console.log(editedEntity)

        if (this.$store.getters.isLargeScreen) {
          this.$forceNextTick(() => this.$refs['titleInput'].focusInput())
        }

        if (!editedEntity) {
          this.deadlineRaw = null
        }

        if (this.task.deadline) {
          if (this.edit) {
            this.deadlineRaw = formatyyymmdd(this.task.deadline.toDate())
          } else {
            this.deadlineRaw = formatyyymmdd(this.task.deadline)
          }
        } else {
          this.deadlineRaw = this.task.showList
        }

        console.log('deadline', this.task.deadline)
        console.log('deadlineRaw', this.deadlineRaw)

        if (editedEntity) {
          await this.$validator.resume()
        } else {
          await this.$validator.pause()
        }
      }
    },
  },
  computed: {
    makeItTitle () {
      const {effort, impact}  = this.task.makeIt

      if (effort == 'low' && impact == 'low') {
        return 'WEAK: can you increase the impact?'
      } else if (effort == 'low' && impact == 'high') {
        return 'GREAT: execute this task right away'
      } else if (effort == 'high' && impact == 'low') {
        return 'BAD: focus on other tasks, or try to delegate it'
      } else if (effort == 'high' && impact == 'high') {
        return 'GOOD: can you reach the same impact with less effort?'
      }
    },
    taskDefaults () {
      return {
        done: false,
        subtasks: [],
        doneOn: null,
        showList: '',
        backgroundColor: '',
        relatedAreas: [],
        whyDescription: '',
        gainDescription: '',
        riskDescription: '',
        makeIt: { effort: '', impact: '' },
        notes: ''
      }
    },
    // validateForm () {
    //   return !this.errors.any()
    // },
    promptActive () {
      return !!this.editedEntity
    },
    lowLowTask () {
      return this.task.makeIt.effort == 'low' &&
      this.task.makeIt.impact == 'low'
    },
    edit () {
      return !!_.get(this.editedEntity, 'id')
    },
  },
  methods: {
    close () {
      // console.log('closing')
      // this.deadlineRaw = ''
      this.$emit('close')
    },
    save () {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return

        if (this.deadlineRaw) {
          if (isMetadate(this.deadlineRaw)) {
            this.task.deadline = null
            this.task.showList = this.deadlineRaw
          } else {
            this.task.deadline = parseInCurrentTimezone(this.deadlineRaw)
          }
        } else {
          this.task.deadline = null
        }

        console.log('saving deadline', this.task.deadline)

        if (this.edit) {
          const {title, deadline, backgroundColor, showList, relatedAreas, whyDescription, gainDescription, riskDescription, makeIt, notes } = this.task
          this.$store.dispatch('UPDATE_TASK', { task: this.editedEntity, updateFields: {title, backgroundColor, deadline: (deadline || null), showList, relatedAreas, whyDescription, gainDescription, riskDescription, makeIt, notes } })
        } else {
          trackAnalytics(this, 'app_action', 'task', 'task_create', this.$store.getters.daysFromRegistration)

          this.$store.dispatch('ADD_TASK', { task: this.task })
        }

        // trackAnalytics(this, 'app_action', this.edit ? 'update_goal' : 'add_goal', null, this.$store.getters.daysFromRegistration)


        this.close()

        if (isFuture(this.task.deadline)) {
          this.notifier.futureTaskAdded(this.$store)
        }
      })
    },
  },
  beforeDestroy () {
    this.$root.$off('taskSidebarFooterSaveClicked')
  },
  mounted () {
    this.$root.$on('taskSidebarFooterSaveClicked', () => {
      this.save()
    })
  },
}
</script>
